import axios from 'axios';

const API = process.env.REACT_APP_APP_API_URL;

// Full wallet sign-in flow: nonce -> personal_sign -> verify -> JWT.
// Returns { token, user, isNew }. Throws with a friendly message on failure.
export async function walletSignIn(address, username) {
    const eth = window.ethereum;
    if (!eth) throw new Error('NO_WALLET');

    const nonceRes = await axios.post(`${API}/api/auth/wallet/nonce`, { address });
    if (!nonceRes.data.status) throw new Error(nonceRes.data.message || 'Could not start wallet login');

    let signature;
    try {
        signature = await eth.request({
            method: 'personal_sign',
            params: [nonceRes.data.message, address],
        });
    } catch (err) {
        if (err && (err.code === 4001 || /rejected|denied/i.test(err.message || ''))) {
            throw new Error('Signature cancelled in wallet');
        }
        throw new Error('Wallet could not sign the message');
    }

    const verifyRes = await axios.post(`${API}/api/auth/wallet/verify`, { address, signature, username });
    if (!verifyRes.data.status) throw new Error(verifyRes.data.message || 'Wallet login failed');

    localStorage.setItem('token', verifyRes.data.token);
    return verifyRes.data;
}
